import { Font } from '@react-pdf/renderer';

import inter300 from '@fontsource/inter/files/inter-latin-300-normal.woff';
import inter400 from '@fontsource/inter/files/inter-latin-400-normal.woff';
import inter500 from '@fontsource/inter/files/inter-latin-500-normal.woff';
import inter600 from '@fontsource/inter/files/inter-latin-600-normal.woff';
import inter700 from '@fontsource/inter/files/inter-latin-700-normal.woff';

import urbanist300 from '@fontsource/urbanist/files/urbanist-latin-300-normal.woff';
import urbanist400 from '@fontsource/urbanist/files/urbanist-latin-400-normal.woff';
import urbanist500 from '@fontsource/urbanist/files/urbanist-latin-500-normal.woff';
import urbanist600 from '@fontsource/urbanist/files/urbanist-latin-600-normal.woff';
import urbanist700 from '@fontsource/urbanist/files/urbanist-latin-700-normal.woff';
import urbanist400Italic from '@fontsource/urbanist/files/urbanist-latin-400-italic.woff';
import urbanist500Italic from '@fontsource/urbanist/files/urbanist-latin-500-italic.woff';
import urbanist600Italic from '@fontsource/urbanist/files/urbanist-latin-600-italic.woff';
import urbanist700Italic from '@fontsource/urbanist/files/urbanist-latin-700-italic.woff';

// Per-weight static font files. Variable fonts don't reliably switch weights
// inside @react-pdf/renderer, so we register one file per weight.

Font.register({
  family: 'Inter',
  fonts: [
    { src: inter300, fontWeight: 300 },
    { src: inter400, fontWeight: 400 },
    { src: inter500, fontWeight: 500 },
    { src: inter600, fontWeight: 600 },
    { src: inter700, fontWeight: 700 },
  ],
});

Font.register({
  family: 'Urbanist',
  fonts: [
    { src: urbanist300, fontWeight: 300 },
    { src: urbanist400, fontWeight: 400 },
    { src: urbanist500, fontWeight: 500 },
    { src: urbanist600, fontWeight: 600 },
    { src: urbanist700, fontWeight: 700 },
    { src: urbanist400Italic, fontWeight: 400, fontStyle: 'italic' },
    { src: urbanist500Italic, fontWeight: 500, fontStyle: 'italic' },
    { src: urbanist600Italic, fontWeight: 600, fontStyle: 'italic' },
    { src: urbanist700Italic, fontWeight: 700, fontStyle: 'italic' },
  ],
});

// Disable react-pdf's default word-break/hyphenation, which can mangle words
// when using custom fonts.
Font.registerHyphenationCallback((word) => [word]);
